import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  FormLabel,
  styled,
} from "@mui/material";
import { Upload as UploadIcon, Close as CloseIcon } from "@mui/icons-material";

const FileUploadBox = styled(Box)(({ theme }) => ({
  border: "1px dashed",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

const UploadIconBox = styled(Box)(({ theme }) => ({
  width: "48px",
  height: "48px",
  border: "1px solid",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(1),
  cursor: "pointer",
}));

const FilePreviewItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: theme.palette.action.hover,
  //padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  //marginTop: theme.spacing(1),
}));

const FileIconBox = styled(Box)(({ theme }) => ({
  width: "32px",
  height: "32px",
  backgroundColor: theme.palette.action.selected,
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: theme.spacing(1),
}));

interface FileUploadProps {
  section: string;
  title: string;
  questionId?: number; // Make questionId optional for non-question uploads
  reportDetailId?: number;
  files: any;
  onUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    questionId?: number,
    reportDetailId?: number
  ) => void;
  onRemove: (
    section: string,
    index: number,
    imageUrl: string,
    questionId?: number
  ) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({
  section,
  title,
  questionId,
  reportDetailId,
  files,
  onUpload,
  onRemove,
}) => {
  console.log(files);
  // if (section === "taskPhotos") {
  //   files = files.map((photo: any) => photo.imageUrl);
  // }

  return (
    <Box sx={{ mb: 2 }}>
      <FormLabel>{title}</FormLabel>
      <Box
        sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}
        data-field={`question_${questionId}_images`}
      >
        {" "}
        {/* Flex container */}
        {/* Upload Box */}
        <FileUploadBox sx={{ flex: 1 }}>
          {" "}
          {/* Adjust width dynamically */}
          <label
            htmlFor={`file-upload-${section}-${questionId || "general"}`}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <UploadIconBox>
              <UploadIcon sx={{ color: "text.secondary" }} />
            </UploadIconBox>
            <Typography variant="body2" color="text.secondary">
              Drag/Upload Here
            </Typography>
          </label>
          <input
            type="file"
            id={`file-upload-${section}-${questionId || "general"}`}
            style={{ display: "none" }}
            multiple
            onChange={(e) => onUpload(e, section, questionId, reportDetailId)}
          />
        </FileUploadBox>
        {/* File Preview Section */}
        {files.filter(Boolean).length > 0 && (
          <Stack
            direction="row"
            spacing={1}
            sx={{ flexWrap: "wrap", alignItems: "flex-start" }}
          >
            {files.filter(Boolean).map((file, index) => {
              let imageUrl = "";
              let key = index;
              let onRemoveId = index;

              if (section === "taskPhotos" && typeof file === "object") {
                imageUrl = file.imageUrl;
                key = file.reportHdrImageId || index;
                onRemoveId = file.reportHdrImageId || index;
              } else if (
                section === "invoiceReceipt" &&
                typeof file === "object"
              ) {
                imageUrl = file.imageUrl;
                key = file.reportHdrInvoiceId || index;
                onRemoveId = file.reportHdrInvoiceId || index;
              } else {
                imageUrl = typeof file === "string" ? file : "";
              }

              return (
                <Box
                  key={key}
                  sx={{
                    width: 150,
                    height: 125,
                    position: "relative",
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid #ccc",
                  }}
                >
                  <img
                    src={imageUrl}
                    alt={`preview-${key}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() =>
                      onRemove(section, onRemoveId, file, questionId)
                    }
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      backgroundColor: "rgba(255,255,255,0.8)",
                      "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                      padding: "2px",
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              );
            })}
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default FileUpload;
